module.exports = __webpack_public_path__ + "static/img/foltest_forged.305a968.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/foltest_forged.png
// module id = J+vK
// module chunks = 0